// extracted by mini-css-extract-plugin
export var chartBox = "transition-scores-module--chart-box--jcFRp";
export var container = "transition-scores-module--container--kWIGX";
export var errorText = "transition-scores-module--error-text--pxIPR";
export var loader = "transition-scores-module--loader--IJPDn";
export var loading = "transition-scores-module--loading--OzTNz";